<template>
  <div class="main">

  </div>
</template>

<script>
import {Dialog} from "vant"
import {loginByCode} from "@/api/module/auth";
import {loginByOpenid} from "@/api/module/user";
export default {
  name: "wechatAuth",
  components: {},
  data() {
    return {
      code:'',
      VUE_APP_GET_OPENID_TYPE:window.g.VUE_APP_GET_OPENID_TYPE,
      VUE_APP_GET_OPENID_URL:window.g.VUE_APP_GET_OPENID_URL
    }
  },
  created() {
    //如果有用户信息，则不进行微信登录
    let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    if (userinfo != undefined && userinfo != null && userinfo.openid != null) {
      //是否开启微信登录
      if (window.g.VUE_APP_ISWECHAT == '1' && localStorage.getItem("loginuser") == null) {
        this.loginByOpenid(userinfo.openid)
      }
    }
    else
    {
      //是否开启微信登录
      if (window.g.VUE_APP_ISWECHAT == '1') {
        if("home_url_param_openId" == this.VUE_APP_GET_OPENID_TYPE){
          window.location.href = this.VUE_APP_GET_OPENID_URL
        }
        else{
          var code = this.getUrlParam('code')
          var local = window.location.href
          if (code == null || code == '') {
            window.location.href =
                'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                window.g.VUE_APP_WECHAT_APPID + '&redirect_uri=' +
                encodeURIComponent(local) +
                '&response_type=code&scope=' + process.env.VUE_APP_WECHAT_TYPE
                + '&state=state#wechat_redirect'
          } else {
            this.code = code
            var data = {
              code: code
            }
            this.getopenid_data(data)
          }
        }
      }
    }
  },
  methods: {
    //微信登录验证部分
    getopenid_data(data) {
      loginByCode(data).then(res => {
        const wechatUserInfo = res.data
        if(wechatUserInfo.openid != null){
          sessionStorage.setItem("userinfo", JSON.stringify(wechatUserInfo));
          this.loginByOpenid(wechatUserInfo.openid)
        }
        else{
          Dialog.alert({
            message: '获取微信ID失败，点击返回尝试重新授权',
          }).then(() => {
            sessionStorage.removeItem("userinfo")
            window.history.replaceState(null, '', '');
            this.$router.go(-1);
            // 2025-08-22 luotong 去除url后面的参数
            let url = window.location.href.split('#')[0]
            let search = url.split('?')[0]
            window.location.href = search
          });

        }
      })
    },
    loginByOpenid(openid){
      let params = {
        wechatid:openid
      }
      loginByOpenid(params).then(res => {
        let _this = this;
        if(res.data!=null){
          let loginuser = JSON.parse(JSON.stringify(res.data))
          localStorage.setItem("loginuser", JSON.stringify(loginuser))
          localStorage.setItem("token",loginuser.token)
          if(this.$route.params.pathName){
            this.$router.push({name: this.$route.params.pathName})
          }
          else{
            this.$router.push({name: 'home'})
          }
        }
        else{
          let url = window.location.href.split('#')[0]
          let search = url.split('?')[0]
          //当前微信未绑定，返回登录页面重新登录进行绑定
          Dialog.alert({
            message: '当前微信未绑定，返回登录页面重新登录进行绑定',
          }).then(() => {
            window.location.href = search + '#/login'
          });
          setTimeout(function (){
            Dialog.close()
            window.location.href = search + '#/login'
          },6000)
        }
      })
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
  }
}
</script>

<style scoped>
</style>
